import { Grid, TextField, Button, Autocomplete, MenuItem } from "@mui/material";

// Delivery Status filter is only shown for "overview" and "all" - every
// other status tab already implies a single delivery_status, so filtering
// by it there wouldn't do anything.
const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  drivers,
  activeTab,
  orderStatuses = [],
  shiftModes = [],
}) => {
  const showStatusFilter = activeTab === "overview" || activeTab === "all";

  return (
    <Grid container spacing={2} rowSpacing={2.25}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Invoice No"
          variant="outlined"
          fullWidth
          value={filterData.invoiceNumber || ""}
          onChange={handleChangeFilter("invoiceNumber")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label="Job No"
          variant="outlined"
          fullWidth
          value={filterData.jobId || ""}
          onChange={handleChangeFilter("jobId")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label="Customer Code"
          variant="outlined"
          fullWidth
          value={filterData.customerCode || ""}
          onChange={handleChangeFilter("customerCode")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Autocomplete
          disablePortal
          options={drivers}
          getOptionLabel={(option) => option.full_name || ""}
          value={
            filterData.driverId
              ? drivers.find((d) => d.driver_id === filterData.driverId) || null
              : null
          }
          onChange={(_, newValue) => {
            handleChangeFilter("driverId")({
              target: { value: newValue ? newValue.driver_id : "" },
            });
          }}
          renderInput={(params) => (
            <TextField {...params} label="Driver" variant="outlined" fullWidth />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          select
          label="Shift"
          variant="outlined"
          fullWidth
          value={filterData.shift || ""}
          onChange={(event) => handleChangeFilter("shift")(event)}
          SelectProps={{ MenuProps: { disablePortal: true } }}
        >
          <MenuItem value="">All</MenuItem>
          {shiftModes.map((mode) => (
            <MenuItem key={mode.id ?? mode.code} value={mode.code}>
              {mode.code}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      {showStatusFilter && (
        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Status"
            variant="outlined"
            fullWidth
            value={filterData.status || ""}
            onChange={(event) => handleChangeFilter("status")(event)}
            SelectProps={{ MenuProps: { disablePortal: true } }}
          >
            <MenuItem value="">All</MenuItem>
            {orderStatuses.map((status) => (
              <MenuItem key={status.code} value={status.code}>
                {status.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      )}

      <Grid
        item
        xs={12}
        display="flex"
        justifyContent="flex-end"
        gap={1.25}
        sx={{ mt: 0.5, pt: 2, borderTop: "1px solid #ECEFF3" }}
      >
        <Button
          variant="outlined"
          onClick={handleClearFilters}
          sx={{
            borderColor: "#7152F3",
            color: "#7152F3",
            "&:hover": {
              borderColor: "#5c34fa",
              backgroundColor: "rgba(113, 82, 243, 0.04)",
            },
          }}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          onClick={handleFilter}
          sx={{
            backgroundColor: "#7152F3",
            "&:hover": { backgroundColor: "#5c34fa" },
          }}
        >
          Filter
        </Button>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
